<template>
    <div>
        <div v-for="(action,index) in value" :key="index">
            <add-line @add-action="addAction(index)" @add-condition="addCondition(index)" />
            <ActionDynamic :action="action" @delete-item="deleteItem(index)" />
        </div>
        <add-line @add-action="addAction(-1)" @add-condition="addCondition(-1)" />
    </div>

</template>

<script>
export default {
	props: ["value"],
	components: {ActionDynamic: () => import("./ActionDynamic"), AddLine: () => import("./AddLine")},
	methods: {
		addAction(index) {
			this.addAtIndex(index, {type: "setVar", props: {name: "", val: ""}});
		},
		addCondition(index) {
			this.addAtIndex(index, {type: "condition", props: {condition: {}, actionsIf: [], actionsElse: []}});
		},
		addAtIndex(index, item) {
			this.value.splice(index === -1 ? this.value.length : index, 0, item);
		},
		deleteItem(index) {
			// let index = this.value.indexOf(action);
			if (index === -1) {
				console.warn("cannot delete, item not found");
			}
			else {
				// this.value = this.value.splice(index, 1);
				console.info("item still not deleted", this.value);
				const shadow = this.value.slice();
				shadow.splice(index, 1);
				console.info("item deleted", index, shadow);
				this.$emit("input", shadow);
			}
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
